<template>
  <div>
    <div :class="$style.heading">
      <lv-heading tag="h3" level="3" version2>
        {{ $awt('aw.common.product.informations.accordion.documents') }}
      </lv-heading>
    </div>
    <ul :class="['ulReset', $style.documentList]">
      <li v-for="document in documents" :key="document.url" :class="$style.documentListItem">
        <span :class="$style.documentIcon">
          <client-only>
            <lv-icon name="document-24" :size="screenRange['tablet-min'] ? 24 : 16" />
          </client-only>
        </span>
        <span v-text="document.nameText" />
        <lv-button
          target="_blank"
          :href="document.url"
          shrink
          styling="small-primary-dark"
          :class="$style.downloadButton"
        >
          <span v-text="$awt('aw.product_document_list.download')" />
          <lv-icon name="download-16" :size="16" :class="$style.downloadIcon" />
        </lv-button>
      </li>
    </ul>
  </div>
</template>
<script setup>
  import { LvHeading, LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface.js';

  defineProps({
    documents: {
      type: Array,
      required: true,
    },
  });
  const screenRange = computed(() => useUserInterfaceStore().mediaQueries);
</script>
<style module lang="scss" rel="stylesheet/scss">
.heading {
  margin-bottom: 40px;

  @include mobile(max) {
    display: none;
  }
}

.documentList {
  font-family: 12px;
  font-weight: 700;
  line-height: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  @include tablet(min) {
    font-family: 14px;
    line-height: 20px;
  }
  @include mobile(max) {
    margin-top: 20px;
  }

  &Item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 1px solid $color-border-disabled;
    background: $color-background-3;

    @include tablet(min) {
      gap: 16px;
      padding: 12px 16px;
    }
  }
}

.documentListItem,
.documentIcon {
  border-radius: 12px;

  @include tablet(min) {
    border-radius: 16px;
  }
}

.documentIcon {
  padding: 8px;
  background: $color-background-1;
}

.downloadButton {
  margin-left: auto;
}

.downloadIcon {
  margin-left: 8px;

  @include mobile(max) {
    display: none;
  }
}
</style>
